import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Icon, Input, Button, Typography } from '@canvas-logic/clp-shared-ui';

import { Card } from '@/UiBuilder/Card/Card';
import { OptionsList } from '@/UiBuilder/OptionsList/OptionsList';
import { ColorCell } from '@/UiBuilder/elements/RalAttributeCfgUIElement/RalAttributeCfgUIElement';

import { Color } from '@/stores/RalConfiguratorUIElementState';

import styles from './RalPalette.module.css';

interface RalPaletteProps {
  title?: string;
  onClickBack: () => void;
  selectedColor?: Color;
  onSelectColor?: (color: string) => void;
  colors: Color[];
}

export const RalPalette = ({ title, onClickBack, selectedColor, onSelectColor, colors }: RalPaletteProps) => {
  const { t: tTranslation } = useTranslation('translation');
  const [filter, setFilter] = useState('');

  const filteredColors = useMemo(() => {
    if (!filter) {
      return colors;
    }

    return colors.filter((color) => color.ral.toLowerCase().includes(filter.toLowerCase()));
  }, [colors, filter]);

  return (
    <>
      <div className={styles.header}>
        <Button
          variant="ghost"
          onClick={onClickBack}
          className={styles.backButton}
          iconStart={<Icon style={{ transform: 'rotate(180deg)' }} type="arrow" />}
        />
        <Typography component="div" variant="heading5">
          {title}
        </Typography>
      </div>
      <Input
        label={tTranslation('configuratorPage.uiBuilder.selectColor')}
        onChange={(e) => setFilter(e.target.value)}
        value={filter}
        placeholder="RAL"
      />
      <div className={styles.divider} />
      <OptionsList className={styles.options}>
        {filteredColors.map((color) => {
          const isSelected = selectedColor?.ral === color.ral;

          return (
            <li key={color.ral}>
              <Card
                orientation="horizontal"
                value={color.ral}
                onSelect={onSelectColor}
                selected={isSelected}
                label={color.ral}
                imageType="icon"
                icon={<ColorCell color={color.hex} width={80} height={80} />}
              />
            </li>
          );
        })}
      </OptionsList>
    </>
  );
};
